import { useFeatureGate } from '../../../hooks/useFeatureGate';
import { isWebsiteTrafficQualityTenantAllowed } from './allowlist';

export type TrafficQualityMode = 'quality' | 'legacy';

export type WebsiteTrafficQualityGate = {
  /** The `website-analytics` feature is on: website statistics show at all. */
  websiteAnalytics: boolean;
  /** Website statistics read the quality route for this tenant. */
  quality: boolean;
  /** Every cache, held figure and request signature keys on this with the tenant, so a flip reuses nothing. */
  mode: TrafficQualityMode;
};

/**
 * One quality-mode decision for every website statistics surface (Stats > Website, Home, the asset sheet, the landing
 * library, the page picker): the existing `website-analytics` gate and the tenant on the rollout list. The allowlist
 * cannot expose statistics the gate hides.
 */
export const useWebsiteTrafficQualityGate = (tenantId: number | undefined): WebsiteTrafficQualityGate => {
  const websiteAnalytics = useFeatureGate().isEnabled('website-analytics');
  const quality = websiteAnalytics && isWebsiteTrafficQualityTenantAllowed(tenantId);
  return { websiteAnalytics, quality, mode: quality ? 'quality' : 'legacy' };
};
